import { render, staticRenderFns } from "./PersonConfirmationData.vue?vue&type=template&id=06ba9990&scoped=true"
import script from "./PersonConfirmationData.vue?vue&type=script&lang=js"
export * from "./PersonConfirmationData.vue?vue&type=script&lang=js"
import style0 from "./PersonConfirmationData.vue?vue&type=style&index=0&id=06ba9990&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ba9990",
  null
  
)

export default component.exports